module.exports = __webpack_public_path__ + "static/img/icon-insurance-09.8e09af95.png";